module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-2-ea4a2fbd5e905eab25835180483760c0.jpg";